"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileUploader = void 0;

var _react = _interopRequireWildcard(require("react"));

require("bootstrap/dist/css/bootstrap.min.css");

require("font-awesome/css/font-awesome.min.css");

require("./FileUploader.css");

var _propTypes = require("prop-types");

var _reactFileDrop = require("react-file-drop");

var _reactI18next = require("react-i18next");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * File Uploader
 *
 * The componenent provides functinoality for file uploader with drag and drop feature 
 * 
 * Following are the inputs for the component:
 *
 * componentType : string, Type for file uploader to show, options are DRAG_DROP_BROWSE or BROWSE
 *
 * acceptFileTypes : array, type of files to accept e.g. ['image/jpeg', 'image/png']
 * 
 * onDropHandler : function, function to be called when file droped or browsed
 *
 * dropTitle : string, title to show on file drop component
 *
 * maxFileSize : number, max allowed file size in bytes
 * 
 * titleType : string, type of title string/component
 *
 * titleComponent : react component, component to be rendered as title
 *
 * onFileRemove : function, function to be called when file is removed
 *
 * layout : string, layout of file uploader, 1column/2column
 *
 * renderUploadedFilesItem : function, function to render uploaded files item, to customize
 * 
 * onRef : function, to pass the reference of child
 *
 * maxFileSizeErrorMessage : string , max file size error message
 *
 * AllowedFileTypesErrorMessage : string, allowed file types error message
 */
var FileUploader = /*#__PURE__*/function (_Component) {
  _inherits(FileUploader, _Component);

  var _super = _createSuper(FileUploader);

  function FileUploader(props) {
    var _this;

    _classCallCheck(this, FileUploader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "resetUploadedFiles", function () {
      _this.setState({
        uploadedFiles: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "browseFiles", function (event) {
      var input_id = _this.props.name ? _this.props.name : 'file';
      var file = document.getElementById(input_id);
      file.click();
    });

    _defineProperty(_assertThisInitialized(_this), "onDropHandler", function (files, event) {
      _this.setState({
        validationMessage: ''
      });

      var fileList = _this.state.uploadedFiles;
      Array.from(files).map(function (file) {
        if (_this.validateFile(file)) {
          var fileWithSuccess = Object.assign(file, {
            success: true
          });

          if (_this.props.restrictMultipleFiles) {
            console.log(fileWithSuccess, "SSSSS");
            fileList = [fileWithSuccess];
          } else {
            fileList.push(fileWithSuccess);
          }
        }

        return file;
      });

      if (_this.props.onDropHandler) {
        _this.props.onDropHandler(fileList, event);
      }

      _this.setState({
        uploadedFiles: fileList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "browsedFilesHandler", function (e) {
      _this.onDropHandler(e.target.files, e);
    });

    _defineProperty(_assertThisInitialized(_this), "removeFile", function (e, file, index) {
      if (_this.props.onFileRemove) {
        _this.props.onFileRemove(file);
      } // remove file


      var filesArray = _this.state.uploadedFiles; // delete filesArray[index];
      // debugger;

      filesArray.splice(index, 1);

      _this.setState({
        uploadedFiles: filesArray
      });
    });

    _this.state = {
      validationMessage: '',
      uploadedFiles: []
    };
    return _this;
  }

  _createClass(FileUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onRef) {
        this.props.onRef(this);
      }

      if (this.props.disabled) {
        document.getElementById(this.props.name).disabled = true;
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.defaultUploadedFiles) {
        this.setState({
          uploadedFiles: this.props.defaultUploadedFiles
        });
      }

      if (this.props.disabled) {
        var el = document.getElementById(this.props.name);

        if (el) {
          el.disabled = true;
        }
      } else {
        var _el = document.getElementById(this.props.name);

        if (_el) {
          _el.disabled = false;
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultUploadedFiles) {
        this.setState({
          uploadedFiles: nextProps.defaultUploadedFiles
        });
      }

      if (nextProps.disabled) {
        var el = document.getElementById(nextProps.name);

        if (el) {
          el.disabled = true;
        }
      } else {
        var _el2 = document.getElementById(this.props.name);

        if (_el2) {
          _el2.disabled = false;
        }
      }
    }
  }, {
    key: "validateFile",
    value: function validateFile(file) {
      var is_valid = true; // check allowed types

      if (this.props.acceptFileTypes && !this.props.acceptFileTypes.includes(file.type)) {
        is_valid = false;

        if (this.props.AllowedFileTypesErrorMessage) {
          this.setState({
            validationMessage: this.props.t(this.props.AllowedFileTypesErrorMessage)
          });
        } else {
          this.setState({
            validationMessage: this.props.t("File type not allowed. Allowed file types are") + this.props.acceptFileTypes.toString()
          });
        }
      } // check allowed File size


      if (this.props.maxFileSize && this.props.maxFileSize < file.size) {
        is_valid = false;

        if (this.props.maxFileSizeErrorMessage) {
          this.setState({
            validationMessage: this.props.t(this.props.maxFileSizeErrorMessage)
          });
        } else {
          this.setState({
            validationMessage: this.props.t('Max allowed file size is ') + this.props.maxFileSize + '!'
          });
        }
      } // check emptry file


      if (this.props.restrictEmptyFiles && file.size === 0) {
        is_valid = false;

        if (this.props.restrictEmptyFilesMessage) {
          this.setState({
            validationMessage: this.props.t(this.props.restrictEmptyFilesMessage)
          });
        } else {
          this.setState({
            validationMessage: this.props.t('Empty file not allowed.')
          });
        }
      } // check special chars in file name


      if (this.props.restrictSpecialChars) {
        var fileNameWithoutExt = file.name.substr(0, file.name.lastIndexOf('.'));
        console.log(fileNameWithoutExt);
        var regex = this.props.regex ? this.props.regex : /^[A-Za-z0-9 ]+$/;
        var result = regex.test(fileNameWithoutExt);

        if (fileNameWithoutExt && !result) {
          is_valid = false;

          if (this.props.restrictSpecialCharsMessage) {
            this.setState({
              validationMessage: this.props.t(this.props.restrictSpecialCharsMessage)
            });
          } else {
            this.setState({
              validationMessage: this.props.t('File name with special characters not allowed.')
            });
          }
        }
      }

      return is_valid;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var _this$props = this.props,
          restrictMultipleFiles = _this$props.restrictMultipleFiles,
          onFrameDragEnter = _this$props.onFrameDragEnter,
          onFrameDragLeave = _this$props.onFrameDragLeave,
          onFrameDrop = _this$props.onFrameDrop,
          onDragOver = _this$props.onDragOver,
          onDragLeave = _this$props.onDragLeave,
          dropTitle = _this$props.dropTitle,
          dropSubTitle = _this$props.dropSubTitle;

      if (this.props.layout === '2column') {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "fi-file-uploader-wrapper row",
          id: "fi-file-uploader-wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-md-6"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "uploader",
          onClick: this.props.componentType && this.props.componentType === 'BROWSE' ? function () {} : this.browseFiles
        }, this.props.componentType && this.props.componentType == 'BROWSE' ? /*#__PURE__*/_react.default.createElement("input", {
          onChange: this.browsedFilesHandler,
          multiple: !restrictMultipleFiles,
          type: "file",
          class: "form-control"
        }) : /*#__PURE__*/_react.default.createElement(_reactFileDrop.FileDrop, {
          onFrameDragEnter: onFrameDragEnter,
          onFrameDragLeave: onFrameDragLeave,
          onFrameDrop: onFrameDrop,
          onDragOver: onDragOver,
          onDragLeave: onDragLeave,
          onDrop: this.onDropHandler,
          className: "file-drop" + " " + this.props.dropbackgroundClass
        }, this.props.titleType === 'component' ? this.props.titleComponent : dropTitle ? /*#__PURE__*/_react.default.createElement("span", {
          className: "drop-title"
        }, " ", t(dropTitle), "  ", /*#__PURE__*/_react.default.createElement("span", {
          className: "dropSubTitle"
        }, t(dropSubTitle))) : /*#__PURE__*/_react.default.createElement("span", {
          className: "drop-title"
        }, t('Drop files here to upload!')), /*#__PURE__*/_react.default.createElement("input", {
          multiple: !restrictMultipleFiles,
          onChange: this.browsedFilesHandler,
          style: {
            visibility: 'hidden'
          },
          type: "file",
          name: this.props.name ? this.props.name : 'file',
          id: this.props.name ? this.props.name : 'file',
          className: "input-file"
        }))), this.state.validationMessage ? /*#__PURE__*/_react.default.createElement("div", {
          className: "file-validation"
        }, this.state.validationMessage) : ''), /*#__PURE__*/_react.default.createElement("div", {
          className: "col-md-6 files upload-file-wrapper"
        }, this.state.uploadedFiles.length > 0 ? /*#__PURE__*/_react.default.createElement("ul", {
          className: "uploaded-files"
        }, this.state.uploadedFiles.map(function (file, index) {
          if (_this2.props.renderUploadedFilesItem) {
            return _this2.props.renderUploadedFilesItem(file, index);
          } else {
            return /*#__PURE__*/_react.default.createElement("li", {
              key: index
            }, /*#__PURE__*/_react.default.createElement("span", {
              className: "file-name"
            }, file.name), /*#__PURE__*/_react.default.createElement("span", {
              className: "action",
              onClick: function onClick(e) {
                return _this2.removeFile(e, file, index);
              }
            }, /*#__PURE__*/_react.default.createElement("i", {
              className: "fa fa-trash"
            })));
          }
        })) : /*#__PURE__*/_react.default.createElement("div", {
          className: "empty-files"
        }, this.props.noFilesMessage ? this.props.noFilesMessage : 'No files uploaded.')));
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "fi-file-uploader-wrapper row",
          id: "fi-file-uploader-wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-md-12"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "uploader",
          onClick: this.props.componentType && this.props.componentType === 'BROWSE' ? function () {} : this.browseFiles
        }, this.props.componentType && this.props.componentType == 'BROWSE' ? /*#__PURE__*/_react.default.createElement("input", {
          onChange: this.browsedFilesHandler,
          multiple: !restrictMultipleFiles,
          type: "file",
          class: "form-control"
        }) : /*#__PURE__*/_react.default.createElement(_reactFileDrop.FileDrop, {
          onFrameDragEnter: onFrameDragEnter,
          onFrameDragLeave: onFrameDragLeave,
          onFrameDrop: onFrameDrop,
          onDragOver: onDragOver,
          onDragLeave: onDragLeave,
          onDrop: this.onDropHandler,
          className: "file-drop" + " " + this.props.dropbackgroundClass
        }, this.props.titleType === 'component' ? this.props.titleComponent : dropTitle ? /*#__PURE__*/_react.default.createElement("span", {
          className: "drop-title"
        }, " ", t(dropTitle), " ", /*#__PURE__*/_react.default.createElement("span", {
          className: "dropSubTitle"
        }, t(dropSubTitle))) : /*#__PURE__*/_react.default.createElement("span", {
          className: "drop-title"
        }, t('Drop files here to upload!')), /*#__PURE__*/_react.default.createElement("input", {
          multiple: !restrictMultipleFiles,
          onChange: this.browsedFilesHandler,
          style: {
            visibility: 'hidden'
          },
          type: "file",
          name: this.props.name ? this.props.name : 'file',
          id: this.props.name ? this.props.name : 'file',
          className: "input-file"
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: "upload-file-wrapper"
        }, this.state.uploadedFiles.length > 0 ? /*#__PURE__*/_react.default.createElement("ul", {
          className: "uploaded-files"
        }, this.state.uploadedFiles.map(function (file, index) {
          if (_this2.props.renderUploadedFilesItem) {
            return _this2.props.renderUploadedFilesItem(file, index);
          } else {
            return /*#__PURE__*/_react.default.createElement("li", {
              key: index
            }, /*#__PURE__*/_react.default.createElement("span", {
              className: "file-name"
            }, file.name), /*#__PURE__*/_react.default.createElement("span", {
              className: "action",
              onClick: function onClick(e) {
                return _this2.removeFile(e, file, index);
              }
            }, /*#__PURE__*/_react.default.createElement("i", {
              className: "fa fa-trash"
            })), /*#__PURE__*/_react.default.createElement("div", {
              className: "bar"
            }, _this2.props.showProgressBar && _this2.props.showProgressBar.show ? /*#__PURE__*/_react.default.createElement("div", {
              className: "progress"
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "progress-bar",
              role: "progressbar",
              "aria-valuenow": "100",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, file.success ? "100%" : "10%")) : ""));
          }
        })) : /*#__PURE__*/_react.default.createElement("div", {
          className: "empty-files"
        }, this.props.noFilesMessage ? this.props.noFilesMessage : 'No files uploaded.')), this.state.validationMessage ? /*#__PURE__*/_react.default.createElement("div", {
          className: "file-validation"
        }, this.state.validationMessage) : ''));
      }
    }
  }]);

  return FileUploader;
}(_react.Component);

exports.FileUploader = FileUploader;

_defineProperty(FileUploader, "propTypes", {
  componentType: _propTypes.PropTypes.string,
  // DRAG_DROP_BROWSE, BROWSE
  acceptFileTypes: _propTypes.PropTypes.array,
  // ['image/jpeg', 'image/png']
  onDropHandler: _propTypes.PropTypes.func,
  dropTitle: _propTypes.PropTypes.string,
  maxFileSize: _propTypes.PropTypes.number
});

var _default = (0, _reactI18next.withTranslation)()(FileUploader);

exports.default = _default;